require('../../modules/es6.math.imul');
module.exports = require('../../modules/_core').Math.imul;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/imul.js
// module id = 348
// module chunks = 10